import { createComponent as a } from "@lit/react";
const i = ({
  defineCustomElement: e,
  ...r
}) => (typeof e < "u" && e(), a(r)), p = ({
  hydrateModule: e,
  properties: r,
  tagName: n
}) => async (t) => {
  const { createComponentForServerSideRendering: o } = await import("./ssr.js");
  return o({
    tagName: n,
    properties: r,
    renderToString: (await e).renderToString
  })(t);
};
export {
  i as createComponent,
  p as createSSRComponent
};
